var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import clsx from 'clsx';
import Anchor from '@telia-front/anchor';
import { useResponsiveProps } from '@telia-front/helper';
import List, { ListItem } from '@telia-front/list';
const HeaderLanguages = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    return responsive ? React.createElement(HeaderLanguagesResponsive, Object.assign({}, rest, { responsive: responsive })) : React.createElement(HeaderLanguagesInner, Object.assign({}, rest));
};
const HeaderLanguagesResponsive = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    const responsiveProps = useResponsiveProps({ responsive });
    return React.createElement(HeaderLanguagesInner, Object.assign({}, rest, responsiveProps));
};
const HeaderLanguagesInner = (props) => {
    const languageItemBEM = (item) => {
        const classArray = ['header__languages-item'];
        if (item.current) {
            classArray.push('is-current');
        }
        return classArray.join(' ');
    };
    const getItems = () => {
        return props.items.map((item, index) => {
            const { label, current } = item, rest = __rest(item, ["label", "current"]);
            return (React.createElement(ListItem, { className: languageItemBEM(item), key: index },
                React.createElement(Anchor, Object.assign({}, rest, { isUnderlined: false, isTextColor: true, className: "header__languages-link", attributes: {
                        'aria-current': current ? 'true' : undefined,
                    } }), label)));
        });
    };
    return (React.createElement("div", { className: clsx('header__languages', {
            [`header__languages--${props.location}`]: !!props.location,
        }) },
        React.createElement(List, { type: "unstyled", direction: "inline", noGutter: "all", className: "header__languages-list" }, getItems())));
};
export default HeaderLanguages;
